import React, { Component } from 'react';
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import {withStyles} from "@material-ui/styles";
import {organisationDetails, saveOrUpdateOrganisationDetails, trackExport} from "../../util/ApiUtils";
import {NotificationContainer, NotificationManager} from 'react-notifications';
import {SystemUpdateAltTwoTone} from "@material-ui/icons";
import * as htmlDocx from "html-docx-js/dist/html-docx";
import {GreenButton} from "../common/ButtonsConstants";
import * as CommonUtils from "../../util/CommonUtils";
import {Editor} from "@tinymce/tinymce-react";
import moment from "moment";

const top = 50;
const left = 50;
const classes = (theme => ({
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    paper: {
        position: 'absolute',
        width: 400,
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    },
    'input': {
        '&::placeholder': {
            textOverflow: 'ellipsis !important',
            background: 'yellow'
        }
    },
}));

class Purpose extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            organisation: null,
            orgId: "",
            orgName: "",
            purpose: "",
            isEditing: false,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.editContent = this.editContent.bind(this);
        this.handleEditorChange = this.handleEditorChange.bind(this);
        this.loadOrganisationDetails = this.loadOrganisationDetails.bind(this);
    }

    componentDidMount() {
        this.loadOrganisationDetails();
    }

    loadOrganisationDetails() {
        organisationDetails()
            .then(response => {
                console.log(response);
                this.setState({
                    orgId: response.id,
                    purpose: response.purpose,
                    content: response.purpose,
                    organisation: response,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    editContent = () => {
        this.setState({
            isEdit: !this.state.isEdit
        });
    };

    handleEditorChange = (content, editor) => {
        this.setState({ content: content });
    };

    handleSubmit(event) {
        event.preventDefault();
        const organisationDetailsRequest = Object.assign(this.state.organisation,
            {id: this.state.orgId, purpose: this.state.content}
        );
        console.log(organisationDetailsRequest);
        saveOrUpdateOrganisationDetails(organisationDetailsRequest)
            .then(() => {
                this.setState({
                    isEdit: false,
                })
                NotificationManager.success('Success', 'The Purpose has been updated.', 5000);
            }).catch(error => {
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    render() {
        const { state } = this;
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        return <div>
            <Typography component="h2" variant="h5">
                PURPOSE
            </Typography>
            {
                !state.isEdit ?
                    (
                        <React.Fragment>
                            {!isDemo && <GreenButton startIcon={<SystemUpdateAltTwoTone/>} onClick={() => { saveAs(htmlDocx.asBlob(this.toRevisionTable(this.props.revision) + "Purpose" + state.content), this.props.exportFileName); trackExport("Purpose"); }} style={{ float: 'right' }}>EXPORT</GreenButton>}
                            <div style={{ clear: 'both' }}/>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: state.content
                                }}>
                            </div>
                            <Button
                                onClick={this.editContent}
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                disabled={isAuditor}
                            >
                                EDIT
                            </Button>
                        </React.Fragment>
                    )
                    :
                    <React.Fragment>
                        <GreenButton
                            onClick={this.handleSubmit}
                            type="submit"
                            style={{ float: 'right' }}
                            variant="contained"
                            color="primary"
                        >
                            SAVE
                        </GreenButton>
                        <div style={{ clear: 'both' }}/>
                        <Editor
                            apiKey="y9iyidzzc5orr4c7nqrr9edoyr9on123bjjw4dfjvfoj54hu"
                            value={ state.content }
                            init={{
                                height: 900,
                                branding: false,
                                menubar: false,
                                plugins: [
                                    'advlist autolink lists link image charmap print preview anchor',
                                    'searchreplace visualblocks code fullscreen',
                                    'insertdatetime media table paste code help wordcount'
                                ],
                                toolbar:
                                    'undo redo | formatselect | bold italic backcolor | \
                                    alignleft aligncenter alignright alignjustify | \
                                    bullist numlist outdent indent | removeformat | help'
                            }}
                            onEditorChange={this.handleEditorChange}
                        />
                    </React.Fragment>
            }
            <NotificationContainer/>
        </div>;
    }
    toRevisionTable(revision) {
        return '<table style="width:100%">' +
            '<tr>' +
            '<b>Revision ' + revision.number + '  Author: ' + revision.author + '</p>' +
            '</tr>' +
            '<tr>' +
            '<td>Approved for suitability and adequacy by: ' + revision.approvedBy + ' on ' + moment(revision.date).format('DD/MM/YYYY') + '</td>' +
            '</tr>' +
            '</table>';
    }
}

export default withStyles(classes)(Purpose);
